/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

window.Popper = require("popper.js");

window.$ = window.jQuery = require("jquery");

require("admin-lte");
require("bootstrap");

window.Vue = require("vue");

import LogHelper from "../js/front/Helpers/LogHelper";
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);

import Swal from "sweetalert2/dist/sweetalert2.js";

const Toast = Swal.mixin({
  toast: true,
  position: "top",
  timer: 3000,
  showConfirmButton: false,
});
window.Toast = Toast;

import money from "v-money";
Vue.use(money, {
  precision: 4,
});

import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

import Carousel3d from "vue-carousel-3d";
Vue.use(Carousel3d);

Vue.config.errorHandler = (err) => {
  const current_page = location.href;
  LogHelper.sendLogToGoogleChat(`Front | ${err}`, 500);
  LogHelper.registerToFrontLogs(`${err}`, current_page);
};

// import vClickOutside from "v-click-outside";
import Axios from "axios";
import { type } from "jquery";

Vue.component(
  "the-testimonies-carousel",
  require("./front/TheTestimoniesCarousel.vue").default
);
Vue.component(
  "the-speakers-carousel",
  require("./front/TheSpeakersCarousel.vue").default
);
Vue.component(
  "the-previous-editions-carousel",
  require("./front/ThePreviousEditionsCarousel.vue").default
);
Vue.component(
  "the-brands-carousel",
  require("./front/TheBrandsCarousel.vue").default
);
Vue.component("the-gallery", require("./front/TheGallery.vue").default);
Vue.component("the-newsletter", require("./front/TheNewsletter.vue").default);
Vue.component(
  "the-insterested-sponsor",
  require("./front/TheSponsorInterest.vue").default
);
Vue.component("the-lp-form", require("./front/TheLPForm.vue").default);
Vue.component("the-banner", require("./front/TheBanner.vue").default);
Vue.component("the-banner-meta", require("./front/TheBannerMeta.vue").default);
Vue.component(
  "the-banner-description",
  require("./front/TheBannerDescription.vue").default
);
Vue.component(
  "the-banner-speakers",
  require("./front/TheBannerSpeakers.vue").default
);
Vue.component("the-galery", require("./front/TheGalery.vue").default);
Vue.component("the-signup", require("./front/TheSignUpForm.vue").default);
Vue.component("the-login", require("./front/TheLoginForm.vue").default);
Vue.component("the-log-out", require("./front/TheLogOut.vue").default);
Vue.component("the-buy", require("./front/TheBuyPassport.vue").default);
Vue.component("the-cart", require("./front/TheCart.vue").default);
Vue.component("the-show", require("./front/TheShowPassport.vue").default);
Vue.component("the-profile", require("./front/TheProfileForm.vue").default);
Vue.component("the-payment", require("./front/ThePayment.vue").default);
Vue.component("the-checkin", require("./front/TheCheckinForm.vue").default);
Vue.component(
  "the-checkin-otr",
  require("./front/TheCheckinOTRForm.vue").default
);
Vue.component(
  "the-forgot-password",
  require("./front/TheForgotPassword.vue").default
);
Vue.component("the-password", require("./front/TheRemakePassword.vue").default);
Vue.component(
  "the-programation",
  require("./front/TheProgramation.vue").default
);
Vue.component(
  "the-blog-gallery",
  require("./front/TheBlogGallery.vue").default
);
Vue.component("the-gallery-lp", require("./front/TheGalleryLP.vue").default);
Vue.component(
  "the-banner-experiencia",
  require("./front/TheBannerExp.vue").default
);
Vue.component(
  "the-banner-experiencia2",
  require("./front/TheBannerExp2.vue").default
);
Vue.component(
  "the-destaque-mobile",
  require("./front/TheDestaqueMobile.vue").default
);
Vue.component(
  "the-carousel-blog",
  require("./front/TheCarouselBlog.vue").default
);
Vue.component(
  "the-tab-scrollable",
  require("./front/TheTabScrollable.vue").default
);
Vue.component("the-certificate", require("./front/Certificate.vue").default);
Vue.component(
  "the-resend-codes",
  require("./front/TheResendCodes.vue").default
);
Vue.component(
  "the-visitor-accreditation",
  require("./front/TheVisitorAccreditation.vue").default
);
Vue.component(
  "the-pre-sign-up",
  require("./front/ThePreSignUpForm.vue").default
);

Vue.component(
  "the-new-programation",
  require("./front/TheNewProgramation.vue").default
);
// Vue.component(
//   "the-city-selector",
//   require("./cms/UISelectCityAndState.vue").default
// );

const app = new Vue({
  el: "#app",
});

$(".cashback-popup").modal();

function UserVerify() {
  if (!("__TMP" in localStorage)) {
    Axios.get("/api/generator")
      .then((response) => {
        const item = {
          key: response.data,
          email: "",
        };
        localStorage.setItem("__TMP", JSON.stringify(item));
        let buttons = document.getElementsByClassName("buy-button");
        for (var i = 0; i < buttons.length; i++) {
          buttons[i].removeAttribute("disabled");
        }
      })
      .catch((error) => {});
  }

  function IsJsonString(key) {
    try {
      var response = JSON.parse(localStorage.getItem(key));
    } catch (e) {
      localStorage.removeItem(key);
      window.location.reload();
    }
    return response;
  }

  if ("__TMP" in localStorage) {
    let buttons = document.getElementsByClassName("buy-button");
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].removeAttribute("disabled");
    }
  }

  if ("__AUTH" in localStorage) {
    const token = IsJsonString("__AUTH");
    const key = IsJsonString("__TMP");
    const now = new Date();
    if (now.getTime() > token.expiry) {
      localStorage.removeItem("__AUTH");
      window.location.reload();
    } else {
      Axios.post("/api/auth/user", {
        token: token.value,
      })
        .then((response) => {
          if (
            window.location.pathname.split("/")[2] == "login" ||
            window.location.pathname.split("/")[2] == "cadastro"
          ) {
            window.location.href = "/cliente/carrinho";
          } else if (document.getElementById("header-button-main")) {
            document.getElementById(
              "header-button-main"
            ).children[0].innerText = "Menu";
          }
          let item = JSON.parse(localStorage.getItem("__TMP"));
          item.email = response.data;
          localStorage.setItem("__TMP", JSON.stringify(item));
          let buttons = document.getElementsByClassName("buy-button");
          for (var i = 0; i < buttons.length; i++) {
            buttons[i].removeAttribute("disabled");
          }
        })
        .catch((e) => {
          if (e.response.data.msg == "Token Inválido") {
            localStorage.removeItem("__AUTH");
            window.location.href = "/cliente/login";
          }
        });
    }
  }
}

if (window.location.pathname == "/") {
  if ("__AUTH" in localStorage) {
    document.querySelector("#contaLogado a").href = "/cliente/meus-passaportes";
    // document.querySelector('#contaLogadoFooter a').href = "/cliente/meus-passaportes";
    document.querySelector("#contaLogadoMenuMobile a").href =
      "/cliente/meus-passaportes";
  } else {
    document.querySelector("#contaLogado a").href = "/cliente/login";
    // document.querySelector('#contaLogadoFooter a').href = "/cliente/login";
    document.querySelector("#contaLogadoMenuMobile a").href = "/cliente/login";
  }
}

if (window.location.pathname.split("/")[1] != "cms") {
  window.addEventListener("storage", (e) => {
    if (e.key === "__TMP") {
      if ("__TMP" in localStorage) {
        if (
          localStorage.getItem("__TMP") === "" ||
          localStorage.getItem("__TMP") === null
        ) {
          localStorage.removeItem("__TMP");
        }
        if (location.pathname.split("/")[2] != "carrinho") {
          location.href = "";
        }
      } else {
        // location.href = "";
        UserVerify();
      }
    } else if (e.key === "__AUTH") {
      location.href = "/cliente/login";
      localStorage.removeItem("__TMP");
    } else if (!("__TMP" in localStorage)) {
      // location.href = "";
    }
  });
  UserVerify();
}

async function assignPassport() {
  await Axios.post("/api/cart/attribution", {
    temp: localStorage.getItem("__TMP"),
    client_id: JSON.parse(localStorage.getItem("__AUTH")).value,
    post_attribution: false,
    cart_id: JSON.parse(localStorage.getItem("cart_id")),
  })
    .then((response) => {
      Swal.fire({
        title: "🚀 Item adicionado 🚀",
        text: "Você está sendo direcionado para o carrinho",
        showConfirmButton: false,
        closeOnClickOutside: false,
        allowOutsideClick: false,
        closeOnClickOutside: false,
      });
      location.href = "/cliente/carrinho";
    })
    .catch((error) => {
      Swal.fire({
        title: "Oops :|",
        text: "Tivemos um pequeno problema. Por favor, tente novamente mais tarde.",
        showCancelButton: false,
        confirmButtonText: "Ok",
        confirmButtonColor: "#6fe335",
      });
      let buttons = document.getElementsByClassName("buy-button");
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].removeAttribute("disabled");
      }
    });
}

//Creates the cart on buy
window.buy = async function (id) {
  if ("__TMP" in localStorage) {
    let buttons = document.getElementsByClassName("buy-button");
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute("disabled", true);
    }
    Swal.fire({
      title: "🚀 Preparar... 🚀",
      text: "Aguarde, estamos adicionando ao carrinho",
      showConfirmButton: false,
      closeOnClickOutside: false,
      allowOutsideClick: false,
      closeOnClickOutside: false,
    });
    Axios.post("/api/cart/create", {
      temp: localStorage.getItem("__TMP"),
      ticket_id: id,
      event_id: 1117,
    })
      .then((response) => {
        if (!("__AUTH" in localStorage)) {
          Swal.fire({
            title: "🚀 Item adicionado 🚀",
            text: "Você está sendo direcionado para o carrinho",
            showConfirmButton: false,
            closeOnClickOutside: false,
            allowOutsideClick: false,
            closeOnClickOutside: false,
          });
          location.href = "/cliente/carrinho";
        }
        if (response.status == 200) {
          assignPassport();
        } else if (response.status == 202) {
          Swal.fire({
            title: "Oops :|",
            text: response.data.error || response.data.max,
            confirmButtonColor: "#28a745",
          });
          let buttons = document.getElementsByClassName("buy-button");
          for (var i = 0; i < buttons.length; i++) {
            buttons[i].removeAttribute("disabled");
          }
        }
      })
      .catch((error) => {
        Swal.fire({
          title: "Oops :|",
          text: "Tivemos um pequeno problema. Por favor, tente novamente mais tarde.",
          showCancelButton: false,
          confirmButtonText: "Ok",
          confirmButtonColor: "#6fe335",
        });
        for (var i = 0; i < buttons.length; i++) {
          buttons[i].removeAttribute("disabled");
        }
      });
  }
};

//Removes the account button if the client is not logged
var local = location.href.split("/");
if (!("__AUTH" in localStorage)) {
  if ("__TMP" in localStorage) {
    if (JSON.parse(localStorage.getItem("__TMP")).email.length > 0) {
      localStorage.removeItem("__TMP");
      location.reload();
    }
  }
  document.getElementById("passports-account").classList.remove("d-lg-flex");
  if (local[4] === "meus-passaportes" || local[4] === "minha-conta") {
    location.href = "/";
  }
  if (local[3] === "cliente" && local[4] != "login" && local[4] != "cadastro") {
    var submenus = document.getElementsByClassName("header__account");
    submenus[0].classList.remove("menu-active");
    submenus[1].classList.remove("menu-active");
    submenus[2].classList.remove("menu-active");

    var submenus = document.getElementById("mobile-menu");
    submenus.children[1].classList.remove("menu-active");
    submenus.children[2].classList.remove("menu-active");
  }
} else {
  if (local[3] === "cliente" && local[4] != "login" && local[4] != "cadastro") {
    document
      .getElementsByClassName("header__account")[3]
      .classList.add("menu-vanish");
    if (window.outerWidth >= 992) {
      document.getElementById("passports-account").classList.remove("d-none");
    }
    // document.getElementById('passports-account').classList.remove('d-lg-flex');
  }
}

var menu_mobile = true;
window.openMobileMenu = function () {
  if (menu_mobile) {
    document
      .getElementsByClassName("header__hamburger")[0]
      .children[0].classList.remove("fa-bars");
    document
      .getElementsByClassName("header__hamburger")[0]
      .children[0].classList.add("fa-times");
    document.getElementById("mobile-menu").classList.add("mobile-active");
    menu_mobile = false;
  } else {
    document
      .getElementsByClassName("header__hamburger")[0]
      .children[0].classList.remove("fa-times");
    document
      .getElementsByClassName("header__hamburger")[0]
      .children[0].classList.add("fa-bars");
    document.getElementById("mobile-menu").classList.remove("mobile-active");
    menu_mobile = true;
  }
};

window.changeLoginSignup = function () {
  var page = location.href.split("/")[4] == "login" ? "cadastro" : "login";
  Swal.fire({
    title: "Ir para " + page,
    text:
      "Você tem certeza que deseja ir para o " +
      page +
      "? " +
      (page != "login"
        ? "Isso apagará seus dados dos campos e-mail e senha."
        : "Isso apagará todos os dados que você preencheu até agora."),
    showCancelButton: true,
    cancelButtonText: "Cancelar",
    confirmButtonText: "Ir para " + page,
    cancelButtonColor: "#DF1949",
    confirmButtonColor: "#8B8B8B",
  }).then((confirm) => {
    if (confirm.value) {
      location.href = "/cliente/" + page;
    }
  });
};

window.logOut = function () {
  Swal.fire({
    title: "<span style='color:white;'>Realmente deseja sair?</span>",
    showCancelButton: true,
    confirmButtonText: `Sair`,
    cancelButtonText: `Cancelar`,
    background: "#231F20",
  }).then((result) => {
    if (result.value) {
      localStorage.clear();
      location.href = "/";
    }
  });
};

if (!("__AUTH" in localStorage)) {
  var submenus_intern = document.getElementById("mobile-menu").children;
  submenus_intern[2].style.display = "none";
  submenus_intern[3].style.display = "none";
  submenus_intern[6].style.display = "none";
  submenus_intern[7].style.display = "none";
} else {
  var submenus_intern = document.getElementById("mobile-menu").children;
  submenus_intern[0].style.display = "none";
}

$("#modal").on("hidden.bs.modal", function () {
  console.log("fechou-video");
  var video = $("#yt-player").attr("src");
  $("#yt-player").attr("src", "");
  $("#yt-player").attr("src", video);
});
$(window).on("load", function () {
  $("#modal_meta").modal("show");
});

// ponto no ticket
if (
  (window.location.pathname === "/" && window.location.hash === "") ||
  window.location.pathname === "/passaporte"
) {
  var price = document.getElementById("price");
  if (price) {
    var valor = price.getAttribute("data-value");
    document.getElementById("price").innerHTML = floatToMoney(valor);
  }
  var price2 = document.getElementById("price2");
  if (price2) {
    var valor = price2.getAttribute("data-value");
    document.getElementById("price2").innerHTML = floatToMoney(valor);
  }

  var price3 = document.getElementsByClassName("price3");
  if (price3) {
    var valor = price3[0].getAttribute("data-value");
    price3[0].innerHTML = floatToMoney(valor);
    var valor = price3[1].getAttribute("data-value");
    price3[1].innerHTML = floatToMoney(valor);
    var valor = price3[2].getAttribute("data-value");
    price3[2].innerHTML = floatToMoney(valor);
  }

  function floatToMoney(float) {
    var formatter = new Intl.NumberFormat("pt-BR", {});
    let formattedNumber = formatter.format(Number(float));
    return !isNaN(Number(float)) ? formattedNumber : "R$ -";
  }
}
window.scrollToSection = function (hash) {
  sessionStorage.setItem("section-hash", hash);
};

window.addEventListener("load", function () {
  if (sessionStorage.getItem("section-hash")) {
    const hash = sessionStorage.getItem("section-hash");
    document.getElementById(hash).scrollIntoView(
      {
        behavior: "smooth",
      },
      0
    );
    sessionStorage.removeItem("section-hash");
  }
});
